import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnimationsModule } from '@ibe.animations/animations.module';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { InputsModule } from '@ibe.components/common/inputs/inputs.module';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { MyDatePickerModule } from 'mydatepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { DirectivesModule } from 'src/app/directives/directives.module';
import { ExtraBagsComponent } from './ancillaries/extra-bags/extra-bags.component';
import { FastTrackComponent } from './ancillaries/fast-track/fast-track.component';
import { LoungeComponent } from './ancillaries/lounge/lounge.component';
import { MusicInstrumentsComponent } from './ancillaries/music-instruments/music-instruments.component';
import { PartnerOfferComponent } from './ancillaries/partner-offer/partner-offer.component';
import { SeatmapComponent } from './ancillaries/seatmap/seatmap.component';
import { SmallPetsComponent } from './ancillaries/small-pets/small-pets.component';
import { SpecialMealsComponent } from './ancillaries/special-meals/special-meals.component';
import { SportsEquipmentComponent } from './ancillaries/sports-equipment/sports-equipment.component';
import { CheckoutAncillariesComponent } from './checkout-ancillaries/checkout-ancillaries.component';
import { TAPCheckoutAncillariesComponent } from './checkout-ancillaries/checkout-ancillaries.tap.component';
import { EditPassengersComponent } from './edit-passengers/edit-passengers.component';
import { DetailsChangesComponent } from './included/details-changes/details-changes.component';
import { DetailsRefundsComponent } from './included/details-refunds/details-refunds.component';
import { PassengersDetailsComponent } from './passengers-details/passengers-details.component';
import { PriceBreakdownComponent } from './price-breakdown/price-breakdown.component';
import { ShoppingBasketComponent } from './shopping-basket/shopping-basket.component';
import { StopoverComponent } from './stopover/stopover.component';
import { TAPNotFoundModule } from '@ibe.components/not-found/not-found.module';
import { INDRAHazmatComponent } from './hazmat/hazmat.component.indra';
import { OriginalFlightsComponent } from './original-flights/original-flights.component';
import { BookingExtrasRentACarComponent } from './booking-extras-rent-a-car/booking-extras-rent-a-car.component';
// import { VoucherOrPromocodeViewComponent } from './voucher-or-promocode-view/voucher-or-promocode-view.component';
// import { BookingTicketConditionsComponent } from './booking-ticket-conditions/booking-ticket-conditions.component';
// import { DetailsFastTrackComponent } from './included/details-fast-track/details-fast-track.component';
// import { DetailsHandLuggageComponent } from './included/details-hand-luggage/details-hand-luggage.component';
// import { DetailsKioskComponent } from './included/details-kiosk/details-kiosk.component';
// import { DetailsLoungeComponent } from './included/details-lounge/details-lounge.component';
// import { DetailsLoyaltyMilesComponent } from './included/details-loyalty-miles/details-loyalty-miles.component';
// import { DetailsLuggageComponent } from './included/details-luggage/details-luggage.component';
// import { DetailsMusicalEquipmentComponent } from './included/details-musical-equipment/details-musical-equipment.component';
// import { DetailsPetsComponent } from './included/details-pets/details-pets.component';
// import { DetailsPremiumBoardingComponent } from './included/details-premium-boarding/details-premium-boarding.component';
// import { DetailsPriorityCheckInComponent } from './included/details-priority-check-in/details-priority-check-in.component';
// import { DetailsSeatComponent } from './included/details-seat/details-seat.component';
// import { DetailsSnacksComponent } from './included/details-snacks/details-snacks.component';
// import { DetailsSportsEquipmentComponent } from './included/details-sports-equipment/details-sports-equipment.component';
// import { PremiumCustomerCentreComponent } from './included/premium-customer-centre/premium-customer-centre.component';
// import { UpgradeMilesAndGoComponent } from './upgrade-miles-and-go/upgrade-miles-and-go.component';
// import { UseMilesInfoComponent } from './use-miles-info/use-miles-info.component';
// import { TravelInsuranceComponent } from './travel-insurance/travel-insurance.component';
// import { PassengerIncludedComponent } from './passenger-included/passenger-included.component';
// import { DanishGuaranteeFundComponent } from './danish-guarantee-fund/danish-guarantee-fund.component';
// import { PartnerHotelComponent } from './partner-hotel/partner-hotel.indra.component';
// import { PartnerHotelFilterComponent } from './partner-hotel-filter/partner-hotel-filter.indra.component';
// import { PartnerHotelDetailComponent } from './partner-hotel-detail/partner-hotel-detail.component';
// import { PartnerHotelLocationComponent } from './partner-hotel-location/partner-hotel-location.component';
// import { SightseeingToursComponent } from './sightseeing-tours/sightseeing-tours.component';
// import { AirportToursComponent } from './airport-tours/airport-tours.component';
// import { LisboaCardDiscountComponent } from './lisboa-card-discount/lisboa-card-discount.component';
// import { PriceBreakdownTttComponent } from './price-breakdown-ttt/price-breakdown-ttt.component';
// import { TAPExtraBagsComponent } from './ancillaries/extra-bags/extra-bags.tap.component';
// import { TAPFastTrackComponent } from './ancillaries/fast-track/fast-track.tap.component';
// import { TAPLoungeComponent } from './ancillaries/lounge/lounge.tap.component';
// import { TAPMusicInstrumentsComponent } from './ancillaries/music-instruments/music-instruments.tap.component';
// import { TAPSmallPetsComponent } from './ancillaries/small-pets/small-pets.tap.component';
// import { TAPSpecialMealsComponent } from './ancillaries/special-meals/special-meals.tap.component';
// import { TAPSportsEquipmentComponent } from './ancillaries/sports-equipment/sports-equipment.tap.component';
// import { BookingPriceBreakdownComponent } from './booking-price-breakdown/booking-price-breakdown.component';
// import { CarbonOffsetComponent } from './carbon-offset/carbon-offset.component';
// import { EditSearchComponent } from './edit-search/edit-search.component';
// import { FareAndTaxesComponent } from './fare-and-taxes/fare-and-taxes.component.old';
// import { FilterFlightsComponent } from './filter-flights/filter-flights.component';
// import { FlightCompleteInfoComponent } from './flight-complete-info/flight-complete-info.component';
// import { FlightDetailsChangesComponent } from './included-flight/details-changes/details-changes.component';
// import { FlightDetailsFastTrackComponent } from './included-flight/details-fast-track/details-fast-track.component';
// import { FlightDetailsHandLuggageComponent } from './included-flight/details-hand-luggage/details-hand-luggage.component';
// import { FlightDetailsLoungeComponent } from './included-flight/details-lounge/details-lounge.component';
// import { FlightDetailsLoyaltyMilesComponent } from './included-flight/details-loyalty-miles/details-loyalty-miles.component';
// import { FlightDetailsLuggageComponent } from './included-flight/details-luggage/details-luggage.component';
// import { FlightDetailsPremiumBoardingComponent } from './included-flight/details-premium-boarding/details-premium-boarding.component';
// import { FlightDetailsPriorityCheckInComponent } from './included-flight/details-priority-check-in/details-priority-check-in.component';
// import { FlightDetailsRefundsComponent } from './included-flight/details-refunds/details-refunds.component';
// import { FlightDetailsSeatComponent } from './included-flight/details-seat/details-seat.component';
// import { FlightDetailsSnacksComponent } from './included-flight/details-snacks/details-snacks.component';
// import { FlightDetailsMealsComponent } from './included-flight/details-meals/details-meals.component';
// import { FlightPremiumCustomerCentreComponent } from './included-flight/premium-customer-centre/premium-customer-centre.component';
// import { MarketLanguageComponent } from './market-language/market-language.component';
// import { INDRASignUpComponent } from './sign-up/sign-up.component';
// import { VoucherOrPromocodeComponent } from './voucher-or-promocode/voucher-or-promocode.component';
// import { VoucherOrPromocodeComponent } from './voucher-or-promocode/voucher-or-promocode.component';
// import { CompareFaresComponent } from './compare-fares/compare-fares.component';
// import { EconomyxtraDetailsComponent } from './economyxtra-details/economyxtra-details.component';
// import { PartnerHotelPassengersComponent } from './partner-hotel-passengers/partner-hotel-passengers.component';
// import { FlightDetailsPriorityLuggageComponent } from './included-flight/details-priority-luggage/details-priority-luggage.component';
// import { TicketConditionsComponent } from './ticket-conditions/ticket-conditions.component';
// import { TAPSeatmapComponent } from './ancillaries/seatmap/seatmap.tap.component';
// import { SeatmapSeatComponent } from './ancillaries/seatmap/seatmap-seat/seatmap-seat.component';
// import { SeatmapRowComponent } from './ancillaries/seatmap/seatmap-row/seatmap-row.component';
// import { PassengersNewComponent } from './passengers-new/passengers-new.component';
// import { ContactsComponent } from './contacts/contacts.component';
// import { FlightsNavigationComponent } from './ancillaries/flights-navigation/flights-navigation.component';

/* REPLICATED FILES */
import { INDRAFlightCompleteInfoComponent } from './flight-complete-info/flight-complete-info.indra.component';
import { INDRABookingPriceBreakdownComponent } from './booking-price-breakdown/booking-price-breakdown.indra.component';
import { INDRABookingPriceBreakdownNewComponent } from './booking-price-breakdown-new/booking-price-breakdown-new.indra.component';
import { INDRABookingPriceBreakdownViewComponent } from './booking-price-breakdown-view/booking-price-breakdown-view.indra.component';
import { INDRAVoucherOrPromocodeComponent } from './voucher-or-promocode/voucher-or-promocode.indra.component';
import { EditSearchComponent } from './edit-search/edit-search.indra.component';
import { INDRASignUpComponent } from './sign-up/sign-up.indra.component';
import { INDRAFlightDetailsChangesComponent } from './included-flight/details-changes/details-changes.indra.component';
import { INDRAFlightDetailsFastTrackComponent } from './included-flight/details-fast-track/details-fast-track.indra.component';
import { INDRAFlightDetailsHandLuggageComponent } from './included-flight/details-hand-luggage/details-hand-luggage.indra.component';
import { INDRAFlightDetailsLoungeComponent } from './included-flight/details-lounge/details-lounge.indra.component';
import { INDRAFlightDetailsLoyaltyMilesComponent } from './included-flight/details-loyalty-miles/details-loyalty-miles.indra.component';
import { INDRAFlightDetailsLuggageComponent } from './included-flight/details-luggage/details-luggage.indra.component';
import { INDRAFlightDetailsPremiumBoardingComponent } from './included-flight/details-premium-boarding/details-premium-boarding.indra.component';
import { INDRAFlightDetailsPriorityCheckInComponent } from './included-flight/details-priority-check-in/details-priority-check-in.indra.component';
import { INDRAFlightDetailsRefundsComponent } from './included-flight/details-refunds/details-refunds.indra.component';
import { INDRAFlightDetailsSeatComponent } from './included-flight/details-seat/details-seat.indra.component';
import { INDRAFlightDetailsSnacksComponent } from './included-flight/details-snacks/details-snacks.indra.component';
import { INDRAFlightDetailsMealsComponent } from './included-flight/details-meals/details-meals.indra.component';
import { INDRAFlightPremiumCustomerCentreComponent } from './included-flight/premium-customer-centre/premium-customer-centre.indra.component';
import { INDRAFlightDetailsPriorityLuggageComponent } from './included-flight/details-priority-luggage/details-priority-luggage.indra.component';
import { INDRAFlightDetailsKioskComponent } from './included-flight/details-kiosk/details-kiosk.indra.component';
import { INDRAEconomyxtraDetailsComponent } from './economyxtra-details/economyxtra-details.indra.component';
import { INDRAFilterFlightsComponent } from './filter-flights/filter-flights.indra.component';
import { INDRAMarketLanguageComponent } from './market-language/market-language.indra.component';
import { INDRAFareAndTaxesComponent } from './fare-and-taxes/fare-and-taxes.indra.component';
import { INDRACompareFaresComponent } from './compare-fares/compare-fares.indra.component';
import { INDRACarbonOffsetComponent } from './carbon-offset/carbon-offset.indra.component';
import { INDRAFastTrackComponent } from './ancillaries/fast-track/fast-track.indra.component';
import { INDRALoungeComponent } from './ancillaries/lounge/lounge.indra.component';
import { INDRAExtraBagsComponent } from './ancillaries/extra-bags/extra-bags.indra.component';
import { INDRAMusicInstrumentsComponent } from './ancillaries/music-instruments/music-instruments.indra.component';
import { INDRASmallPetsComponent } from './ancillaries/small-pets/small-pets.indra.component';
import { INDRASpecialMealsComponent } from './ancillaries/special-meals/special-meals.indra.component';
import { INDRASportsEquipmentComponent } from './ancillaries/sports-equipment/sports-equipment.indra.component';
import { INDRATicketConditionsComponent } from './ticket-conditions/ticket-conditions.indra.component';
import { INDRASeatmapComponent } from './ancillaries/seatmap/seatmap.indra.component';
import { INDRASeatmapSeatComponent } from './ancillaries/seatmap/seatmap-seat/seatmap-seat.indra.component';
import { INDRASeatmapRowComponent } from './ancillaries/seatmap/seatmap-row/seatmap-row.indra.component';
import { INDRAPartnerHotelComponent } from './partner-hotel/partner-hotel.indra.component';
import { INDRAPartnerHotelFilterComponent } from './partner-hotel-filter/partner-hotel-filter.indra.component';
import { INDRAPartnerHotelDetailComponent } from './partner-hotel-detail/partner-hotel-detail.indra.component';
import { INDRAPartnerHotelPassengersComponent } from './partner-hotel-passengers/partner-hotel-passengers.indra.component';
import { INDRAPartnerHotelLocationComponent } from './partner-hotel-location/partner-hotel-location.indra.component';
import { INDRAPassengersNewComponent } from './passengers-new/passengers-new.indra.component';
import { INDRAPassengerDetailMainInfoComponent } from './passengers-details/passengers-details-indra/passenger-detail-main-info/passenger-detail-main-info.indra.component';
import { INDRAPassengerDetailStudentComponent } from './passengers-details/passengers-details-indra/passenger-detail-student/passenger-detail-student.indra.component';
import { INDRAPassengerDetailResidentComponent } from './passengers-details/passengers-details-indra/passenger-detail-resident/passenger-detail-resident.indra.component';
import { INDRAPassengerDetailWorkComponent } from './passengers-details/passengers-details-indra/passenger-detail-work/passenger-detail-work.indra.component';
import { INDRAPassengerDetailChubbComponent } from './passengers-details/passengers-details-indra/passenger-detail-chubb/passenger-detail-chubb.indra.component';
import { INDRAContactsComponent } from './contacts/contacts.indra.component';
import { INDRAFlightsNavigationComponent } from './ancillaries/flights-navigation/flights-navigation.indra.component';
import { INDRADanishGuaranteeFundComponent } from './danish-guarantee-fund/danish-guarantee-fund.indra.component';
import { INDRAPassengerIncludedComponent } from './passenger-included/passenger-included.indra.component';
import { INDRATravelInsuranceComponent } from './travel-insurance/travel-insurance.indra.component';
import { INDRAPriceBreakdownTttComponent } from './price-breakdown-ttt/price-breakdown-ttt.indra.component';
import { INDRAAirportToursComponent } from './airport-tours/airport-tours.indra.component';
import { INDRASightseeingToursComponent } from './sightseeing-tours/sightseeing-tours.indra.component';
import { INDRALisboaCardDiscountComponent } from './lisboa-card-discount/lisboa-card-discount.indra.component';
import { INDRAUseMilesInfoComponent } from './use-miles-info/use-miles-info.indra.component';
import { INDRADetailsFastTrackComponent } from './included/details-fast-track/details-fast-track.indra.component';
import { INDRADetailsHandLuggageComponent } from '@ibe.components/shared/sidebar-views/included/details-hand-luggage/details-hand-luggage.indra.component';
import { INDRADetailsKioskComponent } from '@ibe.components/shared/sidebar-views/included/details-kiosk/details-kiosk.indra.component';
import { INDRADetailsLoungeComponent } from '@ibe.components/shared/sidebar-views/included/details-lounge/details-lounge.indra.component';
import { INDRADetailsLoyaltyMilesComponent } from '@ibe.components/shared/sidebar-views/included/details-loyalty-miles/details-loyalty-miles.indra.component';
import { INDRADetailsLuggageComponent } from '@ibe.components/shared/sidebar-views/included/details-luggage/details-luggage.indra.component';
import { INDRADetailsMusicalEquipmentComponent } from '@ibe.components/shared/sidebar-views/included/details-musical-equipment/details-musical-equipment.indra.component';
import { INDRADetailsPetsComponent } from '@ibe.components/shared/sidebar-views/included/details-pets/details-pets.indra.component';
import { INDRADetailsPremiumBoardingComponent } from '@ibe.components/shared/sidebar-views/included/details-premium-boarding/details-premium-boarding.indra.component';
import { INDRADetailsPriorityCheckInComponent } from '@ibe.components/shared/sidebar-views/included/details-priority-check-in/details-priority-check-in.indra.component';
import { INDRADetailsSeatComponent } from '@ibe.components/shared/sidebar-views/included/details-seat/details-seat.indra.component';
import { INDRADetailsSnacksComponent } from '@ibe.components/shared/sidebar-views/included/details-snacks/details-snacks.indra.component';
import { INDRADetailsSportsEquipmentComponent } from '@ibe.components/shared/sidebar-views/included/details-sports-equipment/details-sports-equipment.indra.component';
import { INDRAPremiumCustomerCentreComponent } from '@ibe.components/shared/sidebar-views/included/premium-customer-centre/premium-customer-centre.indra.component';
import { INDRADetailsPriorityLuggageComponent } from '@ibe.components/shared/sidebar-views/included/details-priority-luggage/details-priority-luggage.indra.component';
import { INDRAUpgradeMilesAndGoComponent } from './upgrade-miles-and-go/upgrade-miles-and-go.indra.component';
import { INDRABookingTicketConditionsComponent } from './booking-ticket-conditions/booking-ticket-conditions.indra.component';
import { INDRAVoucherOrPromocodeViewComponent } from './voucher-or-promocode-view/voucher-or-promocode-view.indra.component';


// from phase 1 codes:
import { PassengersDetailsIndraComponent } from './passengers-details/passengers-details-indra/passengers-details-indra.component';
import { PassengerDetailEmergencyContactComponent } from './passengers-details/passengers-details-indra/passenger-detail-emergency-contact/passenger-detail-emergency-contact.component';
import { PassengersDetailsStoreModule } from './passengers-details/_store/passengers-details-store.module';
import { PassengerDetailPersonalDocumentsComponent } from './passengers-details/passengers-details-indra/passenger-detail-personal-documents/passenger-detail-personal-documents.component';
import { FrequentFlyerComponent } from './passengers-details/passengers-details-indra/frequent-flyer/frequent-flyer.component';
import { PassengerDetailContactsComponent } from './passengers-details/passengers-details-indra/passenger-detail-contacts/passenger-detail-contacts.component';
import { WifiOnboardComponent } from './wifi-onboard/wifi-onboard.component';
import { TAPWifiOnboardComponent } from './wifi-onboard/wifi-onboard.component.tap';
import { DetailsWifiOnboardComponent } from './included-flight/details-wifi-onboard/details-wifi-onboard.component';
import { WhatsIncludedBrandComponent } from './whats-included-brand/whats-included-brand.component';
import { INDRATimeToThinkComponent } from './time-to-think/time-to-think.indra.component';
import { INDRAExtraPrefBoardComponent } from './ancillaries/preferred-boarding/preferred-boarding.indra.component';
import { INDRAPartnerHotelInfoComponent } from './partner-hotel-info/partner-hotel-info.indra.component';
import { INDRAPackComponent } from './ancillaries/pack/pack.indra.component';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		TAPNotFoundModule,
		FormsModule,
		ReactiveFormsModule,
		DirectivesModule,
		InputsModule,
		SVGModule,
		SharedModule,
		MyDatePickerModule,
		AnimationsModule,
		PassengersDetailsStoreModule,
		BsDatepickerModule
	],
	declarations: [
		SeatmapComponent,
		// TAPSeatmapComponent,
		INDRASeatmapComponent,
		FastTrackComponent,
		// TAPFastTrackComponent,
		INDRAFastTrackComponent,
		LoungeComponent,
		// TAPLoungeComponent,
		INDRALoungeComponent,
		// TAPSpecialMealsComponent,
		INDRASpecialMealsComponent,
		// TAPSportsEquipmentComponent,
		INDRASportsEquipmentComponent,
		// TAPMusicInstrumentsComponent,
		INDRAMusicInstrumentsComponent,
		TAPCheckoutAncillariesComponent,
		// TAPSmallPetsComponent,
		INDRASmallPetsComponent,
		ExtraBagsComponent,
		// TAPExtraBagsComponent,
		INDRAExtraBagsComponent,
		// TicketConditionsComponent,
		INDRATicketConditionsComponent,
		INDRAFlightCompleteInfoComponent,
		// ContactsComponent,
		INDRAContactsComponent,
		PassengersDetailsComponent,
		// PassengersNewComponent,
		INDRAPassengersNewComponent,
		// DetailsLoyaltyMilesComponent,
		INDRADetailsLoyaltyMilesComponent,
		PartnerOfferComponent,
		// PassengerIncludedComponent,
		INDRAPassengerIncludedComponent,
		// DetailsSeatComponent,
		INDRADetailsSeatComponent,
		// DetailsHandLuggageComponent,
		INDRADetailsHandLuggageComponent,
		// DetailsLuggageComponent,
		INDRADetailsLuggageComponent,
		// DetailsSnacksComponent,
		INDRADetailsSnacksComponent,
		// DetailsFastTrackComponent,
		INDRADetailsFastTrackComponent,
		// DetailsLoungeComponent,
		INDRADetailsLoungeComponent,
		DetailsRefundsComponent,
		DetailsChangesComponent,
		// DetailsKioskComponent,
		INDRADetailsKioskComponent,
		// DetailsPetsComponent,
		INDRADetailsPetsComponent,
		// DetailsSportsEquipmentComponent,
		INDRADetailsSportsEquipmentComponent,
		// DetailsMusicalEquipmentComponent,
		INDRADetailsMusicalEquipmentComponent,
		// PremiumCustomerCentreComponent,
		INDRAPremiumCustomerCentreComponent,
		INDRADetailsPriorityLuggageComponent,
		// DetailsPremiumBoardingComponent,
		INDRADetailsPremiumBoardingComponent,
		// DetailsPriorityCheckInComponent,
		INDRADetailsPriorityCheckInComponent,
		SpecialMealsComponent,
		SportsEquipmentComponent,
		SmallPetsComponent,
		MusicInstrumentsComponent,
		CheckoutAncillariesComponent,
		ShoppingBasketComponent,
		PriceBreakdownComponent,
		// FareAndTaxesComponent,
		INDRAFareAndTaxesComponent,
		// MarketLanguageComponent,
		INDRAMarketLanguageComponent,
		INDRASignUpComponent,
		// FilterFlightsComponent,
		INDRAFilterFlightsComponent,
		// FlightDetailsSnacksComponent,
		INDRAFlightDetailsSnacksComponent,
		// FlightDetailsMealsComponent,
		INDRAFlightDetailsMealsComponent,
		// FlightDetailsLuggageComponent,
		INDRAFlightDetailsLuggageComponent,
		// FlightDetailsHandLuggageComponent,
		INDRAFlightDetailsHandLuggageComponent,
		// FlightDetailsLoyaltyMilesComponent,
		INDRAFlightDetailsLoyaltyMilesComponent,
		// FlightDetailsSeatComponent,
		INDRAFlightDetailsSeatComponent,
		// FlightDetailsFastTrackComponent,
		INDRAFlightDetailsFastTrackComponent,
		// FlightDetailsLoungeComponent,
		INDRAFlightDetailsLoungeComponent,
		// FlightDetailsChangesComponent,
		INDRAFlightDetailsChangesComponent,
		// FlightDetailsRefundsComponent,
		INDRAFlightDetailsRefundsComponent,
		// FlightPremiumCustomerCentreComponent,
		INDRAFlightPremiumCustomerCentreComponent,
		// FlightDetailsPremiumBoardingComponent,
		INDRAFlightDetailsPremiumBoardingComponent,
		// FlightDetailsPriorityCheckInComponent,
		INDRAFlightDetailsPriorityCheckInComponent,
		// CarbonOffsetComponent,
		INDRACarbonOffsetComponent,
		EditSearchComponent,
		EditPassengersComponent,
		StopoverComponent,
		INDRABookingPriceBreakdownComponent,
		INDRABookingPriceBreakdownNewComponent,
		INDRABookingPriceBreakdownViewComponent,
		INDRAVoucherOrPromocodeComponent,
		// TravelInsuranceComponent,
		INDRATravelInsuranceComponent,
		// CompareFaresComponent,
		INDRACompareFaresComponent,
		// SeatmapSeatComponent,
		INDRASeatmapSeatComponent,
		// SeatmapRowComponent,
		INDRASeatmapRowComponent,
		INDRAUpgradeMilesAndGoComponent,
		INDRAHazmatComponent,
		// DanishGuaranteeFundComponent,
		INDRADanishGuaranteeFundComponent,
		// EconomyxtraDetailsComponent,
		INDRAEconomyxtraDetailsComponent,
		// PartnerHotelComponent,
		INDRAPartnerHotelComponent,
		// PartnerHotelFilterComponent,
		INDRAPartnerHotelFilterComponent,
		// PartnerHotelPassengersComponent,
		INDRAPartnerHotelPassengersComponent,
		// PartnerHotelDetailComponent,
		INDRAPartnerHotelDetailComponent,
		// PartnerHotelLocationComponent,
		INDRAPartnerHotelLocationComponent,
		INDRASightseeingToursComponent,
		// AirportToursComponent,
		INDRAAirportToursComponent,
		// LisboaCardDiscountComponent,
		INDRALisboaCardDiscountComponent,
		OriginalFlightsComponent,
		// FlightsNavigationComponent,
		INDRAFlightsNavigationComponent,
		// FlightDetailsPriorityLuggageComponent
		INDRAFlightDetailsPriorityLuggageComponent,
		INDRAFlightDetailsKioskComponent,
		BookingExtrasRentACarComponent,
		INDRAPriceBreakdownTttComponent,
		PassengersDetailsIndraComponent,
		PassengerDetailEmergencyContactComponent,
		PassengerDetailPersonalDocumentsComponent,
		FrequentFlyerComponent,
		PassengerDetailContactsComponent,
		INDRAPassengerDetailMainInfoComponent,
		INDRAPassengerDetailStudentComponent,
		INDRAPassengerDetailResidentComponent,
		INDRAPassengerDetailWorkComponent,
		INDRAPassengerDetailChubbComponent,
		// UseMilesInfoComponent
		INDRAUseMilesInfoComponent,
		// VoucherOrPromocodeViewComponent,
		INDRAVoucherOrPromocodeViewComponent,
		// BookingTicketConditionsComponent
		INDRABookingTicketConditionsComponent,
		WhatsIncludedBrandComponent,
		WifiOnboardComponent,
		TAPWifiOnboardComponent,
		DetailsWifiOnboardComponent,
		INDRATimeToThinkComponent,
		INDRAExtraPrefBoardComponent,
		INDRAPartnerHotelInfoComponent,
		INDRAPackComponent,
	],
	exports: [
		// TAPSeatmapComponent,
		INDRASeatmapComponent,
		// SeatmapSeatComponent,
		INDRASeatmapSeatComponent,
		// SeatmapRowComponent,
		INDRASeatmapRowComponent,
		// TAPExtraBagsComponent,
		INDRAExtraBagsComponent,
		// TAPFastTrackComponent,
		INDRAFastTrackComponent,
		// TAPLoungeComponent,
		INDRALoungeComponent,
		INDRACarbonOffsetComponent,
		// TAPSpecialMealsComponent,
		INDRASpecialMealsComponent,
		// TAPSportsEquipmentComponent,
		INDRASportsEquipmentComponent,
		// TAPMusicInstrumentsComponent,
		INDRAMusicInstrumentsComponent,
		// TAPSmallPetsComponent,
		INDRASmallPetsComponent,
		TAPCheckoutAncillariesComponent,
		// TicketConditionsComponent,
		INDRATicketConditionsComponent,
		// DetailsLoyaltyMilesComponent,
		INDRADetailsLoyaltyMilesComponent,
		// DetailsSeatComponent,
		INDRADetailsSeatComponent,
		// DetailsHandLuggageComponent,
		INDRADetailsHandLuggageComponent,
		PartnerOfferComponent,
		// DetailsLuggageComponent,
		INDRADetailsLuggageComponent,
		// DetailsSnacksComponent,
		INDRADetailsSnacksComponent,
		// DetailsLoungeComponent,
		INDRADetailsLoungeComponent,
		DetailsRefundsComponent,
		DetailsChangesComponent,
		// DetailsFastTrackComponent,
		INDRADetailsFastTrackComponent,
		// SignUpComponent
		INDRASignUpComponent,
		// FlightDetailsSnacksComponent,
		INDRAFlightDetailsSnacksComponent,
		// FlightDetailsMealsComponent,
		INDRAFlightDetailsMealsComponent,
		// FlightDetailsLuggageComponent,
		INDRAFlightDetailsLuggageComponent,
		// FlightDetailsHandLuggageComponent,
		INDRAFlightDetailsHandLuggageComponent,
		// FlightDetailsLoyaltyMilesComponent,
		INDRAFlightDetailsLoyaltyMilesComponent,
		// FlightDetailsSeatComponent,
		INDRAFlightDetailsSeatComponent,
		// FlightDetailsFastTrackComponent,
		INDRAFlightDetailsFastTrackComponent,
		// FlightDetailsLoungeComponent,
		INDRAFlightDetailsLoungeComponent,
		// FlightDetailsChangesComponent,
		INDRAFlightDetailsChangesComponent,
		// FlightDetailsRefundsComponent,
		INDRAFlightDetailsRefundsComponent,
		// FlightPremiumCustomerCentreComponent,
		INDRAFlightPremiumCustomerCentreComponent,
		// FlightDetailsPremiumBoardingComponent,
		INDRAFlightDetailsPremiumBoardingComponent,
		// FlightDetailsPriorityCheckInComponent,
		INDRAFlightDetailsPriorityCheckInComponent,
		EditSearchComponent,
		OriginalFlightsComponent,
		// FlightDetailsPriorityLuggageComponent
		INDRAFlightDetailsPriorityLuggageComponent,
		INDRAFlightDetailsKioskComponent,
		// PartnerHotelPassengersComponent,
		INDRAPartnerHotelPassengersComponent,
		BookingExtrasRentACarComponent,
		// BookingTicketConditionsComponent
		INDRABookingTicketConditionsComponent,
		INDRATimeToThinkComponent,
		INDRAExtraPrefBoardComponent,
		INDRAPartnerHotelInfoComponent,
		INDRAPackComponent,
	]
})
export class SidebarViewsModule { }
